import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface HeaderCell {
  label: string;
  className: string;
}

interface Props {
  headers: HeaderCell[];
  children: ReactNode;
  gapClassName?: string;
  minWidth?: string;
}

export function ReportTable({
  headers,
  children,
  gapClassName = 'gap-2',
  minWidth = '900px',
}: Props) {
  return (
    <div className='border border-border/30 rounded-2xl overflow-x-auto'>
      <div style={{ minWidth }}>
        <div
          className={cn(
            'grid grid-cols-12 px-4 py-2.5 text-xs font-medium text-muted-foreground uppercase tracking-wider bg-muted/20 border-b border-border/20 text-center',
            gapClassName
          )}
        >
          {headers.map((header) => (
            <div key={header.label} className={header.className}>
              {header.label}
            </div>
          ))}
        </div>
        {children}
      </div>
    </div>
  );
}
